// extracted by mini-css-extract-plugin
export default {"link":"MobileMenuSidebar_link__yQyUH","sidebar":"MobileMenuSidebar_sidebar__Abps9"};